<template>
  <div>
    <div class="container">
      <div class="row">
        <div class="col-md-8">
          <h2 class="text-left text-white">Competições</h2>

          <div class="row event-list">
            <div class="col-md-4 col-single-event" v-if="event !== null && k < 9" v-for="(event,k) in events.data" >
              <router-link :to="{ name: 'event', params: { id: event.id }}">
                <div class="single-event-list" :style="`background-image: linear-gradient(to bottom, rgba(0,0,0,0) 0%,rgba(0,0,0,1) 100%),url('`+$urlOrDefault(event.cover_picture,'event-cover')+`');`">
                  <h5 class="text-white">{{ event.name }}</h5>
                  <div class="event-stripe"></div>
                </div>
              </router-link>

            </div>
          </div>

        </div>

        <div class="col-md-4">
          <h2 class="text-left text-white">Jogos</h2>
          <MatchList></MatchList>
        </div>
      </div>
    </div>


    <div class="row other-events-list" style="background-color: #28333A;">
      <div class="container">
        <div class="col-md-12">

          <div class="row">
            <div class="col-md-9">
              <h4 class="text-left text-white">Outras competições</h4>
            </div>
            <div class="col-md-3">
              <!--<input type="text" placeholder="pesquisar competições" class="search-events">-->
            </div>
          </div>

          <div class="row other-event-list">
            <div class="col-md-3 col-single-other-event" v-if="event !== null && k < 12" v-for="(event,k) in otherEvents" >
              <a :href="event.link" target="_blank">
                <div class="single-event-list" :style="`background-image: linear-gradient(to bottom, rgba(0,0,0,0) 0%,rgba(0,0,0,1) 100%),url('`+$urlOrDefault(event.image,'event-cover')+`');`">
                  <h5 class="text-white">{{ event.title }}</h5>
                  <div class="event-stripe"></div>
                </div>
              </a>

            </div>
          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import EventRepository from "@/api/EventRepository";
import MatchList from "@/components/Match/MatchList";
import RtpArenaApi from "@/api/RtpArenaApi";

export default {
  name: "Events",
  components: {MatchList},
  data() {
    return {
      events: {},
      otherEvents: {},
    }
  },
  created() {
    EventRepository.get().then(response => {
      this.events=response.data;
    });

    RtpArenaApi.getEvents(12).then(response => {
      this.otherEvents=response.data;
    })
  }
}
</script>

<style scoped>
  .single-event-list,.single-other-events-list {
    height: 330px;
    background-size: cover;
    background-position: center center;
    text-align: left;
    position: relative;
    width: 100%;
  }

  .single-event-list > h5, .single-other-events-list > h5 {
    position: absolute;
    text-shadow: 2px 2px #000;
    bottom: 5px;
    width: 90%;
    left: 5%;
  }

  .event-list {
    margin-top: 18px;
  }

  .event-stripe {
    position: absolute;
    width: 95%;
    bottom:0;
    left: 2.5%;
    height: 2px;
    background-color: #005CFF;
    display: none;
  }

  .col-single-event:nth-child(n+4){
    margin-top: 40px;
  }

  .col-single-other-event:nth-child(n+5){
    margin-top: 40px;
  }

  .other-events-list {
    margin-top: 70px;
    padding-bottom: 150px;
  }

  .other-events-list h4 {
    margin-top: 20px;
  }

  .other-event-list {
    margin-top: 35px;
  }

  .search-events {
    margin-top: 15px;
    background-color: transparent;
    border-top: none;
    border-left: none;
    border-right: none;
    border-bottom: 1px solid #78838A;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 36px;
    color: #78838A;
    padding-left: 0;
    float: right;
    background-image: url('https://i.imgur.com/DhhnGtL.png');
    background-repeat: no-repeat;
    background-position: right center;
  }
</style>

<style>
.bg-color { background-color:#005CFF!important; } .text-color { color:#005CFF!important; } .border-color { border-color:#005CFF!important; } .fill-color { fill:#005CFF!important; }
</style>

<style>
#app {
  background: #141F26;
  min-height: 100vh;
}
</style>